import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthStage, User } from '@shared/types';

interface AuthState {
  stage: AuthStage;
  user: User | null;
  accessToken: string | null;
  setStage: (stage: AuthStage) => void;
  setUser: (user: User | null) => void;
  setAccessToken: (token: string | null) => void;
  patchUser: (patch: Partial<User>) => void;
  signOut: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      stage: 'auth',
      user: null,
      accessToken: null,
      setStage: (stage) => set({ stage }),
      setUser: (user) => set({ user }),
      setAccessToken: (accessToken) => set({ accessToken }),
      patchUser: (patch) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...patch } : state.user,
        })),
      signOut: () => set({ stage: 'auth', user: null, accessToken: null }),
    }),
    {
      name: 'lx.auth',
      version: 1,
    },
  ),
);
